"use client";
import Link from "next/link";
import Image from "next/image";
import { Carousel } from 'antd';
import FSC from "@/app/assets/product/FSC.svg";
import BEC from "@/app/assets/product/BEC.svg";
import GreenGuard from "@/app/assets/product/GreenGuard.svg";
import { RateCustom } from "./RateCustom";
import ImageWithSkeleton from "./ImageWithSkeleton";
import Global from "@/utils/global";
import "./style/ProductCard.css";
import { useEffect, useState, useRef } from "react";
import { changeUrl, preloadImage, handleUrlSpecialChar, throttle } from "@/utils/tools";
import { Numeric } from "@/app/components/common/Numeric";
import { CarouselEffect } from "antd/es/carousel";

type CertificateProps = {
  icon: string;
  width: number;
};

export type ProductCardProps = {
  product: string;
  navBgIconSize?: number;
  navIconSize?: number;
  container?: string;
  img?: string[];
  currentPrice?: number;
  originalPrice?: number;
  ratingNum?: number;
  remarkNum?: number;
  isRating?: boolean;
  isIcon?: boolean;
  iconSize?: number;
  certificate?: Array<CertificateProps>;
  key?: string;
  spuCode?: string;
  type?: number;
  linkUrl?: string;
  marginTitleTop?: string;
  contentHeight?: string;
  idx?: number,
  category?: string
};


export const ProductCard: React.FC<ProductCardProps> = ({
  idx,
  category = "",
  img = [""],
  // width = 247,
  // height = 247,
  isRating = true,
  isIcon = false,
  iconSize = 34,
  spuCode = "",
  type = 1,
  ratingNum = 0,
  remarkNum,
  navBgIconSize = "19%",
  navIconSize = 26,
  linkUrl = "",
  marginTitleTop = "mt-24",
  contentHeight = "h-176",
  ...props
}) => {
  const [effect, setEffect] = useState<CarouselEffect>("scrollx"); // 控制切换效果
  const [autoSwitching, setAutoSwitching] = useState(false); // 控制自动切换状态
  // 轮播图片移动的下标位置
  const [carouselIndex, setCarouselIndex] = useState(0);
  // 图片的下标
  const carouselRef = useRef<any>(null);
  let isClickValue = false
  useEffect(() => {
    // img?.forEach((item, idx) => {
    //   if (idx !== 0) {
    //     setTimeout(() => {
    //       preloadImage(Global.imageUrl! + handleUrlSpecialChar(item))
    //     }, 200)
    //   }
    // })
  }, [])

  // 通过 ref 调用 Carousel 的 next() 方法
  const goToNext = throttle((index: number) => {
    setTimeout(() => {
      if (carouselRef.current) {
        // carouselRef.current.next(); // 调用 next() 方法切换到下一项
        carouselRef.current.goTo(index || 1);
      }
    }, 100)
  }, 500);

  // 通过 ref 调用 Carousel 的 next() 方法
  const goToPrev = throttle((index: number) => {
    setTimeout(() => {
      if (carouselRef.current) {
        // carouselRef.current.prev(); // 调用 next() 方法切换到下一项
        carouselRef.current.goTo(index || 0);
      }
    }, 100)
  }, 500);

  useEffect(() => {
    if (autoSwitching) {
      setTimeout(() => {
        !isClickValue && goToNext(1)
      }, 100);
    } else {
      setTimeout(() => {
        !isClickValue && goToPrev(0)
      }, 100);
    }
  }, [autoSwitching]);

  return (
    <div 
      className={`${props?.container ?? "w-180 lg:w-247"} productCard`} 
      data-product-id={spuCode}
      data-product-name={props.product}
      data-product-category={category}
      data-product-price={props?.currentPrice}
      data-product-idx={idx}
      data-content-id={idx}
      data-content-position={spuCode}
      data-content-name={props.product}
    >
      <Link href={changeUrl(linkUrl || '')} target="_blank" onClick={() => {
        // @ts-ignore
        window.gtag('event', 'item_click', {
          'items': JSON.stringify([
            {
              'id': spuCode,
              'name': props.product,
              'brand': 'Bravve',
              'category': category, // 商品类别
              'variant': linkUrl,
              'price': props?.currentPrice,
              'list_position': idx
            }
          ]),
          ...{
            'id': spuCode,
            'name': props.product,
            'brand': 'Bravve',
            'category': category, // 商品类别
            'variant': linkUrl,
            'price': props?.currentPrice,
            'list_position': idx
          }
        });
      }}>
        <div style={{ position: "relative" }}
          onMouseLeave={(e) => {
            if (carouselIndex === 0 || carouselIndex === 1) {
              !isClickValue && setEffect("fade"); // 切换为渐变效果
              setAutoSwitching(false); // 停止切换状态
            }
          }}
          onMouseEnter={(e) => {
            if (carouselIndex === 0 || carouselIndex === 1) {
              !isClickValue && setEffect("fade"); // 切换为渐变效果
              setAutoSwitching(true); // 开启切换状态
            }
          }}
        >
          {/* 左箭头 */}
          {img.length > 1 && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                top: "50%",
                marginTop: `calc(-${navBgIconSize} / 2)`,
                width: navBgIconSize,
                height: navBgIconSize,
                maxWidth: '36px',
                maxHeight: '48px',
              }}
              onClick={(e) => {
                // isClickValue = true
                carouselRef.current.prev()
                e.preventDefault();
              }}
              onMouseEnter={(e) => {
                setEffect("scrollx"); // 切换为左右滑动效果
              }}
              onMouseLeave={(e) => {
                setEffect("fade"); // 切换为渐隐效果
              }}
            >
              <div
                className="navShow"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <iconpark-icon
                  icon-id="left"
                  size={`${navIconSize}`}
                  name="left"
                  color={"#402C22"}
                ></iconpark-icon>
              </div>
            </div>
          )}
          <Carousel
            dots={false}
            ref={carouselRef}
            effect={effect}
            speed={500}
            easing="ease-in-out"
            beforeChange={(currentSlide, nextSlide) => {
              setTimeout(() => {
                setCarouselIndex(nextSlide)
              }, 550)
            }}
            style={{ width: "100%", aspectRatio: "1 / 1" }}
          >
            {
              img.map((item, idx) =>
                <ImageWithSkeleton
                  key={item}
                  src={Global.imageUrl! + handleUrlSpecialChar(item)}
                  width={247}
                  height={247}
                  alt={props.product}
                />
                // <Image
                //   key={item}
                //   src={Global.imageUrl! + handleUrlSpecialChar(item)}
                //   width={247}
                //   height={247}
                //   sizes="100vw"
                //   className="h-auto w-full rounded bg-bravve-bg-100"
                //   alt={props.product}
                // />
              )
            }
          </Carousel>
          <div className="mx-3">
            <div className="navShow bg-[#dbdbdb] text-white w-[99%] h-3 bottom-0 absolute flex items-center">
              {
                img && img.length > 0 ? img.map((item, index) => {
                  return (
                    <div key={index + 'line_point'} style={{ width: `calc(100% / ${img.length})` }} className={`${index == carouselIndex ? 'bg-[#222]' : ''} h-full `}>
                      {/* {carouselIndex} */}
                    </div>
                  )
                }) : false
              }
            </div>
          </div>
          {/* 右箭头 */}
          {img.length > 1 && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                right: 0,
                top: "50%",
                marginTop: `calc(-${navBgIconSize} / 2)`,
                width: navBgIconSize,
                height: navBgIconSize,
                maxWidth: '36px',
                maxHeight: '48px',
              }}
              onClick={(e) => {
                // isClickValue = true
                carouselRef.current.next()
                e.preventDefault();
              }}

              onMouseEnter={(e) => {
                setEffect("scrollx"); // 切换为左右滑动效果
              }}
              onMouseLeave={(e) => {
                setEffect("fade"); // 切换为左右渐隐效果
              }}
            >
              <div
                className="navShow"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <iconpark-icon
                  icon-id="right"
                  size={`${navIconSize}`}
                  name="right"
                  color={"#402C22"}
                ></iconpark-icon>
              </div>
            </div>
          )}
        </div>

        {
          type === 1 ?
            (
              <div className={contentHeight}>
                {
                  ratingNum === 0 ?
                    <>
                      <div className="w-48 h-20 font-medium mt-24 text-xs text-white bg-bravve-100 flex items-center justify-center">
                        NEW
                      </div>
                      <h3 className={`productName mt-10 line-clamp-2 break-words text-lg text-bravve-100 `}>
                        {props.product}
                      </h3>
                    </>
                    :
                    <h3 className={`productName mt-24 line-clamp-2 break-words text-lg text-bravve-100 ${marginTitleTop}`}>
                      {props.product}
                    </h3>
                }
                <div className="mt-10">
                  <span className="text-2xl font-bold text-bravve-100">
                    <Numeric value={props?.currentPrice} />
                  </span>
                  {/* <span className="ml-6 text-bravve-sub-100 line-through">
                    <Numeric value={props?.originalPrice} />
                  </span> */}
                </div>
                <div className="flex">
                  {isRating && ratingNum && remarkNum ? <RateCustom value={ratingNum} /> : null}
                  {isRating && ratingNum ? <span className="ml-6 text-bravve-sub-100">{remarkNum}</span> : null}
                </div>
                {isIcon && (
                  <div className="mt-10 flex space-x-8">
                    <FSC width={iconSize} />
                    <BEC width={iconSize} />
                    <GreenGuard width={iconSize} />
                  </div>
                )}
              </div>
            )
            :
            (
              <div className="mt-16">
                <span className="text-lg text-bravve-100 underline">
                  View details
                </span>
              </div>
            )
        }
      </Link>
    </div>
  );
};
